// extracted by mini-css-extract-plugin
export default {"container":"fJYX","title":"EWmT","subtitle":"p8Sh","image":"GRej","buttonGroup":"oC6F","button":"cd1H","closeButton":"l0_9"};